var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        { staticClass: "patsnap-biz-bio_search_setting" },
        [
          _vm.isActive(_vm.settingConfig.algorithmType) && _vm.isInBio
            ? _c(
                "section",
                { staticClass: "row-space search-preference__alg" },
                [
                  _c(
                    "h4",
                    { staticClass: "search-preferences--section__title" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Search.labels.algorithmType")) +
                          " "
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "row-space" }, [
                    _c(
                      "div",
                      { staticClass: "search-preference__alg-label" },
                      [
                        _c(
                          "label",
                          { staticClass: "search-preferences--radio" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.settingConfig.algorithmType.value,
                                  expression:
                                    "settingConfig.algorithmType.value",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value:
                                  _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast,
                                checked: _vm._q(
                                  _vm.settingConfig.algorithmType.value,
                                  _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast
                                ),
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    return _vm.$set(
                                      _vm.settingConfig.algorithmType,
                                      "value",
                                      _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES
                                        .Blast
                                    )
                                  },
                                  function ($event) {
                                    return _vm.handelFieldChange(
                                      _vm.settingConfig.algorithmType
                                    )
                                  },
                                ],
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "search-preferences--value" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "Search.labels.algorithmTypes.Blast"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "label",
                          { staticClass: "search-preferences--radio" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.settingConfig.algorithmType.value,
                                  expression:
                                    "settingConfig.algorithmType.value",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value:
                                  _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.NW,
                                checked: _vm._q(
                                  _vm.settingConfig.algorithmType.value,
                                  _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.NW
                                ),
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    return _vm.$set(
                                      _vm.settingConfig.algorithmType,
                                      "value",
                                      _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.NW
                                    )
                                  },
                                  function ($event) {
                                    return _vm.handelFieldChange(
                                      _vm.settingConfig.algorithmType
                                    )
                                  },
                                ],
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "search-preferences--value" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("Search.labels.algorithmTypes.Nw")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "ElPopover",
                          {
                            attrs: {
                              "visible-arrow": false,
                              width: 458,
                              placement: "right",
                              trigger: "hover",
                              "popper-class": "bio-search-setting__popover",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "preferences-propver__container" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "preferences-propver__content space-y-2",
                                  },
                                  [
                                    _c("p", {
                                      staticClass: "leading-4",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Search.propver.Preferences.algorithmDescription.1"
                                          )
                                        ),
                                      },
                                    }),
                                    _c("img", {
                                      attrs: {
                                        src: _vm.safeImagesUrl(
                                          "globalAlignmentExplanation.1"
                                        ),
                                      },
                                    }),
                                    _c("p", {
                                      staticClass: "leading-4",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Search.propver.Preferences.algorithmDescription.2"
                                          )
                                        ),
                                      },
                                    }),
                                    _c("img", {
                                      attrs: {
                                        src: _vm.safeImagesUrl(
                                          "globalAlignmentExplanation.2"
                                        ),
                                      },
                                    }),
                                    _c("p", {
                                      staticClass: "leading-4",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "Search.propver.Preferences.algorithmDescription.3"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _c("PtIcon", {
                              staticStyle: { "margin-left": "12px" },
                              attrs: { slot: "reference", icon: "SolidInfo" },
                              slot: "reference",
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.isNWAlgorithmType && _vm.isInBio
            ? [
                _c(
                  "h4",
                  { staticClass: "search-preferences--section__title" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Search.labels.algorithmSettings")) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "section",
                  { staticClass: "search-preferences-new--section w-full" },
                  [
                    _c("div", { staticStyle: { width: "234px" } }, [
                      _vm.isActive(_vm.settingConfig.ungapped)
                        ? _c("div", { staticClass: "row-space" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  { staticClass: "search-preference__title" },
                                  [_vm._v(_vm._s(_vm.$t("Search.labels.gaps")))]
                                ),
                                _c(
                                  "ElPopover",
                                  {
                                    attrs: {
                                      "visible-arrow": false,
                                      width: 366,
                                      placement: "right",
                                      trigger: "hover",
                                      "popper-class":
                                        "bio-search-setting__popover",
                                    },
                                  },
                                  [
                                    _c("preferences-propver", {
                                      attrs: {
                                        type: "gaps",
                                        "img-src": _vm.safeImagesUrl(
                                          "ungappedExplanation"
                                        ),
                                      },
                                    }),
                                    _c("PtIcon", {
                                      attrs: {
                                        slot: "reference",
                                        icon: "SolidInfo",
                                      },
                                      slot: "reference",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "search-preference__gaps-label" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "search-preferences--radio" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.settingConfig.ungapped.value,
                                          expression:
                                            "settingConfig.ungapped.value",
                                        },
                                      ],
                                      attrs: { type: "radio" },
                                      domProps: {
                                        value: true,
                                        checked: _vm._q(
                                          _vm.settingConfig.ungapped.value,
                                          true
                                        ),
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            return _vm.$set(
                                              _vm.settingConfig.ungapped,
                                              "value",
                                              true
                                            )
                                          },
                                          function ($event) {
                                            return _vm.handelFieldChange(
                                              _vm.settingConfig.ungapped
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "search-preferences--value",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Search.labels.yes"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "label",
                                  { staticClass: "search-preferences--radio" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.settingConfig.ungapped.value,
                                          expression:
                                            "settingConfig.ungapped.value",
                                        },
                                      ],
                                      attrs: { type: "radio" },
                                      domProps: {
                                        value: false,
                                        checked: _vm._q(
                                          _vm.settingConfig.ungapped.value,
                                          false
                                        ),
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            return _vm.$set(
                                              _vm.settingConfig.ungapped,
                                              "value",
                                              false
                                            )
                                          },
                                          function ($event) {
                                            return _vm.handelFieldChange(
                                              _vm.settingConfig.ungapped
                                            )
                                          },
                                        ],
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "search-preferences--value",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Search.labels.no"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "row-space" },
                        [
                          _vm.isActive(_vm.settingConfig.similarity)
                            ? _c(
                                "SliderRow",
                                {
                                  staticClass: "row-space",
                                  attrs: {
                                    id: "test_similarity_slider",
                                    value: _vm.settingConfig.similarity.value,
                                    label: _vm.$t("Search.labels.similarity"),
                                  },
                                  on: {
                                    "update:value": [
                                      function ($event) {
                                        return _vm.$set(
                                          _vm.settingConfig.similarity,
                                          "value",
                                          $event
                                        )
                                      },
                                      function ($event) {
                                        return _vm.handelFieldChange(
                                          _vm.settingConfig.similarity,
                                          true
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("template", { slot: "label" }, [
                                    _c(
                                      "div",
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Search.labels.alignmentIdentity"
                                              )
                                            )
                                          ),
                                        ]),
                                        _c(
                                          "ElPopover",
                                          {
                                            attrs: {
                                              "visible-arrow": false,
                                              width: 366,
                                              placement: "right",
                                              trigger: "hover",
                                              "popper-class":
                                                "bio-search-setting__popover",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "preferences-propver__container",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "preferences-propver__content",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.safeImagesUrl(
                                                          "globalAlignmentSimilarityExplanation"
                                                        ),
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex items-center text-xs mt-2 text-black-default",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mr-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Search.labels.alignmentIdentity"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mx-2",
                                                          },
                                                          [_vm._v(" = ")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "inline-flex flex-col text-center",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "px-1 mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Search.explanation.identityLength"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "bg-black-default h-[1px]",
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "px-1 mt-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Search.explanation.alignLength"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "mx-2",
                                                          },
                                                          [_vm._v(" = ")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "inline-flex flex-col text-center",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "px-1 mb-1",
                                                              },
                                                              [_vm._v("4")]
                                                            ),
                                                            _c("span", {
                                                              staticClass:
                                                                "bg-black-default h-[1px]",
                                                            }),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "px-1 mt-1",
                                                              },
                                                              [_vm._v("8")]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c("PtIcon", {
                                              staticClass: "ml-2",
                                              attrs: {
                                                slot: "reference",
                                                icon: "SolidInfo",
                                              },
                                              slot: "reference",
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.isActive(_vm.settingConfig.gapExtend)
                        ? _c(
                            "div",
                            { staticClass: "row-space" },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "search-preference__title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("Search.labels.gapExtend")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("ElInputNumber", {
                                staticClass: "search-preferences--number-input",
                                attrs: { size: "small", precision: 0, min: 0 },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isNumber($event)
                                  },
                                  change: function ($event) {
                                    return _vm.handelFieldChange(
                                      _vm.settingConfig.gapExtend
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.settingConfig.gapExtend.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settingConfig.gapExtend,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "settingConfig.gapExtend.value",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isActive(_vm.settingConfig.gapOpen)
                        ? _c(
                            "div",
                            { staticClass: "row-space" },
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  { staticClass: "search-preference__title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("Search.labels.gapOpen")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("ElInputNumber", {
                                staticClass: "search-preferences--number-input",
                                attrs: { size: "small", precision: 0, min: 0 },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isNumber($event)
                                  },
                                  change: function ($event) {
                                    return _vm.handelFieldChange(
                                      _vm.settingConfig.gapOpen
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.settingConfig.gapOpen.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settingConfig.gapOpen,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "settingConfig.gapOpen.value",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isActive(_vm.settingConfig.scoreMatrix)
                        ? _c("div", { staticClass: "row-space" }, [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "search-preference__title" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("Search.labels.scoreMatrix")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              [
                                _c(
                                  "ElSelect",
                                  {
                                    staticClass: "search-preference__select",
                                    attrs: { size: "small" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handelFieldChange(
                                          _vm.settingConfig.scoreMatrix
                                        )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.settingConfig.scoreMatrix.value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settingConfig.scoreMatrix,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settingConfig.scoreMatrix.value",
                                    },
                                  },
                                  _vm._l(
                                    _vm.ScoreMatrixOptions,
                                    function (name) {
                                      return _c(
                                        "ElOption",
                                        { key: name, attrs: { value: name } },
                                        [_vm._v(" " + _vm._s(name) + " ")]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.isActive(_vm.settingConfig.targetSeqLimit)
                        ? _c("div", { staticClass: "row-space" }, [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "search-preference__title" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("Search.labels.targetSeqLimit")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              [
                                _c(
                                  "ElSelect",
                                  {
                                    staticClass: "search-preference__select",
                                    attrs: {
                                      id: "target_seq_limit_select",
                                      size: "small",
                                    },
                                    on: {
                                      change: function (value) {
                                        _vm.updateUserSetting({
                                          key: "limit",
                                          value: value,
                                        })
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.settingConfig.targetSeqLimit.value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.settingConfig.targetSeqLimit,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "settingConfig.targetSeqLimit.value",
                                    },
                                  },
                                  _vm._l(
                                    _vm.targetSeqLimitOptionsFinal,
                                    function (option) {
                                      return _c(
                                        "ElOption",
                                        {
                                          key: option.value,
                                          attrs: {
                                            value: option.value,
                                            disabled: option.disabled,
                                          },
                                        },
                                        [
                                          option.tooltip
                                            ? _c(
                                                "ElTooltip",
                                                {
                                                  attrs: {
                                                    placement: "right-start",
                                                    effect: "light",
                                                    "visible-arrow": false,
                                                    content: option.tooltip,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(option.label)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(option.label) +
                                                    " "
                                                ),
                                              ]),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            : [
                !_vm.isAntibody && !_vm.isCdr && !_vm.externalDbTypeSeqType
                  ? _c("section", { staticClass: "row-space" }, [
                      _c(
                        "h4",
                        { staticClass: "search-preferences--section__title" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Search.labels.databaseTitle")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "search-preferences-new--section" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "search-preferences-database",
                              class: { block: _vm.isMotif2 },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "search-preferences-database__item",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "search-summary__field" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("Search.labels.predicted")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "search-summary__block" },
                                    _vm._l(_vm.SEQUENCE_TYPES, function (t) {
                                      return _c(
                                        "div",
                                        {
                                          key: t,
                                          staticClass: "search-summary__option",
                                        },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.settingConfig
                                                      .sequenceType.value,
                                                  expression:
                                                    "settingConfig.sequenceType.value",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: t,
                                                checked: _vm._q(
                                                  _vm.settingConfig.sequenceType
                                                    .value,
                                                  t
                                                ),
                                              },
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    return _vm.$set(
                                                      _vm.settingConfig
                                                        .sequenceType,
                                                      "value",
                                                      t
                                                    )
                                                  },
                                                  _vm.updateSequenceType,
                                                ],
                                              },
                                            }),
                                            _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Search.btns." +
                                                        t.toLowerCase()
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "search-preferences-database__item",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "search-summary__field" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("Search.labels.database")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  (_vm.isSequence || _vm.isShort) &&
                                  !_vm.radioDbType
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "search-summary__block",
                                        },
                                        _vm._l(
                                          _vm.DATABASE_TYPES,
                                          function (t) {
                                            return _c(
                                              "div",
                                              {
                                                key: t,
                                                staticClass:
                                                  "search-summary__option",
                                              },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.multiDbType,
                                                        expression:
                                                          "multiDbType",
                                                      },
                                                    ],
                                                    attrs: {
                                                      disabled:
                                                        _vm.multiDbType
                                                          .length === 1 &&
                                                        _vm.multiDbType[0] ===
                                                          t,
                                                      type: "checkbox",
                                                      name: "dbType",
                                                    },
                                                    domProps: {
                                                      value: t,
                                                      checked: Array.isArray(
                                                        _vm.multiDbType
                                                      )
                                                        ? _vm._i(
                                                            _vm.multiDbType,
                                                            t
                                                          ) > -1
                                                        : _vm.multiDbType,
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          var $$a =
                                                              _vm.multiDbType,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = t,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                (_vm.multiDbType =
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ]))
                                                            } else {
                                                              $$i > -1 &&
                                                                (_vm.multiDbType =
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    ))
                                                            }
                                                          } else {
                                                            _vm.multiDbType =
                                                              $$c
                                                          }
                                                        },
                                                        _vm.handleChangeMultipleDbType,
                                                      ],
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Search.btns." +
                                                            t.toLowerCase()
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "search-summary__block",
                                        },
                                        _vm._l(
                                          _vm.DATABASE_TYPES,
                                          function (t) {
                                            return _c(
                                              "div",
                                              {
                                                key: t,
                                                staticClass:
                                                  "search-summary__option",
                                              },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.settingConfig
                                                            .dbType.value,
                                                        expression:
                                                          "settingConfig.dbType.value",
                                                      },
                                                    ],
                                                    attrs: {
                                                      disabled: _vm.isMotif,
                                                      type: "radio",
                                                    },
                                                    domProps: {
                                                      value: t,
                                                      checked: _vm._q(
                                                        _vm.settingConfig.dbType
                                                          .value,
                                                        t
                                                      ),
                                                    },
                                                    on: {
                                                      change: [
                                                        function ($event) {
                                                          return _vm.$set(
                                                            _vm.settingConfig
                                                              .dbType,
                                                            "value",
                                                            t
                                                          )
                                                        },
                                                        _vm.updateDbType,
                                                      ],
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Search.btns." +
                                                            t.toLowerCase()
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm.isInBio &&
                      !_vm.externalDbTypeSeqType &&
                      _vm.isSlowSearch
                        ? _c(
                            "div",
                            { staticClass: "slow-warning" },
                            [
                              _c("PtIcon", { attrs: { icon: "SolidWarning" } }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Search.propver.Preferences.slowWarning"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "search-preferences-new--container__main" },
                  [
                    _c("div", { staticClass: "search-preferences-new--item" }, [
                      _c(
                        "h4",
                        { staticClass: "search-preferences--section__title" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Search.labels.searchParameters")) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "section",
                        {
                          staticClass:
                            "search-preferences-new--section fit-parent-height",
                        },
                        [
                          _vm.isActive(_vm.settingConfig.sequenceLength) ||
                          _vm.isActive(_vm.settingConfig.multiSequenceLength)
                            ? _c("div", { staticClass: "row-space" }, [
                                _c("div", [
                                  !_vm.isMultiDbType
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "search-preference__title",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Search.labels.subjectLength"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "search-preference__title--multi",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "search-preference__title",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Search.labels.subjectNucLength"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "search-preference__title",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Search.labels.subjectProteinLength"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "search-preference__gaps-label",
                                  },
                                  [
                                    !_vm.isMultiDbType
                                      ? _c(
                                          "div",
                                          { staticClass: "common-range" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "common-range-group",
                                              },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "common-range-group__input",
                                                  staticStyle: {
                                                    "text-align": "right",
                                                  },
                                                  attrs: {
                                                    maxlength: 9,
                                                    type: "text",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.settingConfig
                                                        .sequenceLength
                                                        .value[0],
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.isNumber(
                                                        $event
                                                      )
                                                    },
                                                    blur: _vm.onStartChange,
                                                  },
                                                }),
                                                _c("div", {
                                                  staticClass:
                                                    "common-range-group__separator",
                                                }),
                                                _c("input", {
                                                  staticClass:
                                                    "common-range-group__input",
                                                  staticStyle: {
                                                    "text-align": "left",
                                                  },
                                                  attrs: {
                                                    maxlength: 9,
                                                    placeholder: "∞",
                                                    type: "text",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.settingConfig
                                                        .sequenceLength
                                                        .value[1],
                                                  },
                                                  on: {
                                                    keypress: function (
                                                      $event
                                                    ) {
                                                      return _vm.isNumber(
                                                        $event
                                                      )
                                                    },
                                                    blur: _vm.onEndChange,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "common-range--multi",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "common-range" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "common-range-group",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "common-range-group__input sequence",
                                                      staticStyle: {
                                                        "text-align": "right",
                                                      },
                                                      attrs: {
                                                        maxlength: 9,
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.settingConfig
                                                            .multiSequenceLength
                                                            .value
                                                            .nucleotide[0],
                                                      },
                                                      on: {
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          return _vm.isNumber(
                                                            $event
                                                          )
                                                        },
                                                        blur: _vm.onMultiNucStartChange,
                                                      },
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "common-range-group__separator",
                                                    }),
                                                    _c("input", {
                                                      staticClass:
                                                        "common-range-group__input sequence",
                                                      staticStyle: {
                                                        "text-align": "left",
                                                      },
                                                      attrs: {
                                                        maxlength: 9,
                                                        placeholder: "∞",
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.settingConfig
                                                            .multiSequenceLength
                                                            .value
                                                            .nucleotide[1],
                                                      },
                                                      on: {
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          return _vm.isNumber(
                                                            $event
                                                          )
                                                        },
                                                        blur: _vm.onMultiNucEndChange,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "common-range" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "common-range-group",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "common-range-group__input sequence",
                                                      staticStyle: {
                                                        "text-align": "right",
                                                      },
                                                      attrs: {
                                                        maxlength: 9,
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.settingConfig
                                                            .multiSequenceLength
                                                            .value.protein[0],
                                                      },
                                                      on: {
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          return _vm.isNumber(
                                                            $event
                                                          )
                                                        },
                                                        blur: _vm.onMultiProteinStartChange,
                                                      },
                                                    }),
                                                    _c("div", {
                                                      staticClass:
                                                        "common-range-group__separator",
                                                    }),
                                                    _c("input", {
                                                      staticClass:
                                                        "common-range-group__input sequence",
                                                      staticStyle: {
                                                        "text-align": "left",
                                                      },
                                                      attrs: {
                                                        maxlength: 9,
                                                        placeholder: "∞",
                                                        type: "text",
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm.settingConfig
                                                            .multiSequenceLength
                                                            .value.protein[1],
                                                      },
                                                      on: {
                                                        keypress: function (
                                                          $event
                                                        ) {
                                                          return _vm.isNumber(
                                                            $event
                                                          )
                                                        },
                                                        blur: _vm.onMultiProteinEndChange,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm.isActive(_vm.settingConfig.similarity)
                            ? _c(
                                "SliderRow",
                                {
                                  staticClass: "row-space",
                                  attrs: {
                                    id: "test_similarity_slider",
                                    value: _vm.settingConfig.similarity.value,
                                    label: _vm.$t("Search.labels.similarity"),
                                  },
                                  on: {
                                    "update:value": [
                                      function ($event) {
                                        return _vm.$set(
                                          _vm.settingConfig.similarity,
                                          "value",
                                          $event
                                        )
                                      },
                                      function ($event) {
                                        return _vm.handelFieldChange(
                                          _vm.settingConfig.similarity,
                                          true
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Search.labels.similarity")
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "ElPopover",
                                        {
                                          attrs: {
                                            placement: "right",
                                            trigger: "hover",
                                            "visible-arrow": false,
                                          },
                                        },
                                        [
                                          _c("AlignmentExplanation", {
                                            attrs: {
                                              "img-src": _vm.safeImagesUrl(
                                                "similarityExplanation"
                                              ),
                                            },
                                          }),
                                          _c("PtIcon", {
                                            attrs: {
                                              slot: "reference",
                                              icon: "SolidInfo",
                                            },
                                            slot: "reference",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.isActive(_vm.settingConfig.querySimilarity)
                            ? _c("SliderRow", {
                                staticClass: "row-space",
                                attrs: {
                                  id: "test_query_similarity_slider",
                                  value:
                                    _vm.settingConfig.querySimilarity.value,
                                  label: _vm.$t("Search.labels.queryIdentity"),
                                },
                                on: {
                                  "update:value": [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.settingConfig.querySimilarity,
                                        "value",
                                        $event
                                      )
                                    },
                                    function ($event) {
                                      return _vm.handelFieldChange(
                                        _vm.settingConfig.querySimilarity,
                                        true
                                      )
                                    },
                                  ],
                                },
                              })
                            : _vm._e(),
                          _vm.isActive(_vm.settingConfig.queryCoverage)
                            ? _c("SliderRow", {
                                staticClass: "row-space",
                                attrs: {
                                  id: "test_query_coverage_slider",
                                  value: _vm.settingConfig.queryCoverage.value,
                                  label: _vm.$t("Search.labels.qconv"),
                                },
                                on: {
                                  "update:value": [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.settingConfig.queryCoverage,
                                        "value",
                                        $event
                                      )
                                    },
                                    function ($event) {
                                      return _vm.handelFieldChange(
                                        _vm.settingConfig.queryCoverage,
                                        true
                                      )
                                    },
                                  ],
                                },
                              })
                            : _vm._e(),
                          _vm.isActive(_vm.settingConfig.subjectSimilarity)
                            ? _c("SliderRow", {
                                staticClass: "row-space",
                                attrs: {
                                  id: "test_subject_similarity_slider",
                                  value:
                                    _vm.settingConfig.subjectSimilarity.value,
                                  label: _vm.$t(
                                    "Search.labels.subjectIdentity"
                                  ),
                                },
                                on: {
                                  "update:value": [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.settingConfig.subjectSimilarity,
                                        "value",
                                        $event
                                      )
                                    },
                                    function ($event) {
                                      return _vm.handelFieldChange(
                                        _vm.settingConfig.subjectSimilarity,
                                        true
                                      )
                                    },
                                  ],
                                },
                              })
                            : _vm._e(),
                          _vm.isActive(_vm.settingConfig.subjectCoverage)
                            ? _c("SliderRow", {
                                staticClass: "row-space",
                                attrs: {
                                  id: "test_subject_coverage_slider",
                                  value:
                                    _vm.settingConfig.subjectCoverage.value,
                                  label: _vm.$t(
                                    "Search.labels.subjectCoverage"
                                  ),
                                },
                                on: {
                                  "update:value": [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.settingConfig.subjectCoverage,
                                        "value",
                                        $event
                                      )
                                    },
                                    function ($event) {
                                      return _vm.handelFieldChange(
                                        _vm.settingConfig.subjectCoverage,
                                        true
                                      )
                                    },
                                  ],
                                },
                              })
                            : _vm._e(),
                          _vm.isActive(_vm.settingConfig.targetSeqLimit) &&
                          _vm.isInBio &&
                          _vm.externalDbTypeSeqType
                            ? _c("div", { staticClass: "row-space" }, [
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "search-preference__title" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "Search.labels.targetSeqLimit"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "ElSelect",
                                      {
                                        staticClass:
                                          "search-preference__select",
                                        attrs: {
                                          id: "target_seq_limit_select",
                                          size: "small",
                                        },
                                        on: {
                                          change: function (value) {
                                            _vm.updateUserSetting({
                                              key: "limit",
                                              value: value,
                                            })
                                          },
                                        },
                                        model: {
                                          value:
                                            _vm.settingConfig.targetSeqLimit
                                              .value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settingConfig.targetSeqLimit,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settingConfig.targetSeqLimit.value",
                                        },
                                      },
                                      _vm._l(
                                        _vm.targetSeqLimitOptionsFinal,
                                        function (option) {
                                          return _c(
                                            "ElOption",
                                            {
                                              key: option.value,
                                              attrs: {
                                                value: option.value,
                                                disabled: option.disabled,
                                              },
                                            },
                                            [
                                              option.tooltip
                                                ? _c(
                                                    "ElTooltip",
                                                    {
                                                      attrs: {
                                                        placement:
                                                          "right-start",
                                                        effect: "light",
                                                        "visible-arrow": false,
                                                        content: option.tooltip,
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(option.label)
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(option.label) +
                                                        " "
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    !_vm.isMotif2 && !_vm.isFragment
                      ? _c(
                          "div",
                          { staticClass: "search-preferences-new--item" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "search-preferences--section__title",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("Search.labels.algorithmSettings")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "section",
                              {
                                staticClass: "search-preferences-new--section",
                              },
                              [
                                _vm.isActive(_vm.settingConfig.ungapped)
                                  ? _c("div", { staticClass: "row-space" }, [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "search-preference__title",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("Search.labels.gaps")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "ElPopover",
                                            {
                                              attrs: {
                                                "visible-arrow": false,
                                                width: 366,
                                                placement: "right",
                                                trigger: "hover",
                                                "popper-class":
                                                  "bio-search-setting__popover",
                                              },
                                            },
                                            [
                                              _c("preferences-propver", {
                                                attrs: {
                                                  type: "gaps",
                                                  "img-src": _vm.safeImagesUrl(
                                                    "ungappedExplanation"
                                                  ),
                                                },
                                              }),
                                              _c("PtIcon", {
                                                attrs: {
                                                  slot: "reference",
                                                  icon: "SolidInfo",
                                                },
                                                slot: "reference",
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "search-preference__gaps-label",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "search-preferences--radio",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.settingConfig.ungapped
                                                        .value,
                                                    expression:
                                                      "settingConfig.ungapped.value",
                                                  },
                                                ],
                                                attrs: { type: "radio" },
                                                domProps: {
                                                  value: true,
                                                  checked: _vm._q(
                                                    _vm.settingConfig.ungapped
                                                      .value,
                                                    true
                                                  ),
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      return _vm.$set(
                                                        _vm.settingConfig
                                                          .ungapped,
                                                        "value",
                                                        true
                                                      )
                                                    },
                                                    function ($event) {
                                                      return _vm.handelFieldChange(
                                                        _vm.settingConfig
                                                          .ungapped
                                                      )
                                                    },
                                                  ],
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "search-preferences--value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Search.labels.yes"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "search-preferences--radio",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.settingConfig.ungapped
                                                        .value,
                                                    expression:
                                                      "settingConfig.ungapped.value",
                                                  },
                                                ],
                                                attrs: { type: "radio" },
                                                domProps: {
                                                  value: false,
                                                  checked: _vm._q(
                                                    _vm.settingConfig.ungapped
                                                      .value,
                                                    false
                                                  ),
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      return _vm.$set(
                                                        _vm.settingConfig
                                                          .ungapped,
                                                        "value",
                                                        false
                                                      )
                                                    },
                                                    function ($event) {
                                                      return _vm.handelFieldChange(
                                                        _vm.settingConfig
                                                          .ungapped
                                                      )
                                                    },
                                                  ],
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "search-preferences--value",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Search.labels.no")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            ),
                            !_vm.isMultiDbType && _vm.isShowAlgorithm
                              ? _c("div", [
                                  _vm.isActive(
                                    _vm.settingConfig.defaultAlgorithm
                                  )
                                    ? _c(
                                        "h4",
                                        {
                                          staticClass:
                                            "search-preferences--section__title",
                                          staticStyle: { "margin-top": "16px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "PtCheckbox",
                                                {
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleAlgorithmFieldsChange(
                                                        _vm.settingConfig
                                                          .defaultAlgorithm
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.settingConfig
                                                        .defaultAlgorithm.value,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.settingConfig
                                                          .defaultAlgorithm,
                                                        "value",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "settingConfig.defaultAlgorithm.value",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Search.labels.defaultAlgorithm"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "ElPopover",
                                                {
                                                  attrs: {
                                                    placement: "right",
                                                    trigger: "hover",
                                                    "visible-arrow": false,
                                                    width: 366,
                                                    "popper-class":
                                                      "bio-search-setting__popover",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Search.propver.Preferences.defaultAlgorithm"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("PtIcon", {
                                                    attrs: {
                                                      slot: "reference",
                                                      icon: "SolidInfo",
                                                    },
                                                    slot: "reference",
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isShort
                                    ? _c(
                                        "section",
                                        {
                                          staticClass:
                                            "search-preferences-new--section",
                                        },
                                        [
                                          _vm.isActive(
                                            _vm.settingConfig.wordSize
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "row-space" },
                                                [
                                                  _c(
                                                    "div",
                                                    { attrs: { span: 10 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "search-preference__title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Search.labels.wordSize"
                                                                )
                                                              ) +
                                                              "(" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Search.labels.wordSizeHold"
                                                                )
                                                              ) +
                                                              ") "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { attrs: { span: 14 } },
                                                    [
                                                      _c(
                                                        "ElSelect",
                                                        {
                                                          staticClass:
                                                            "search-preference__select",
                                                          attrs: {
                                                            id: "test_short_word_size_select",
                                                            placeholder:
                                                              "Word size",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleAlgorithmFieldsChange(
                                                                _vm
                                                                  .settingConfig
                                                                  .wordSize
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.settingConfig
                                                                .wordSize.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .settingConfig
                                                                  .wordSize,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "settingConfig.wordSize.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.settingConfig
                                                            .wordSize.options,
                                                          function (option) {
                                                            return _c(
                                                              "ElOption",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isActive(_vm.settingConfig.algorithm)
                                    ? _c(
                                        "section",
                                        {
                                          staticClass:
                                            "search-preferences-new--section",
                                          class: {
                                            mt16: !_vm.isActive(
                                              _vm.settingConfig.defaultAlgorithm
                                            ),
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row-space" },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "search-preference__title",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Search.labels.algorithm"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c(
                                                      "ElPopover",
                                                      {
                                                        attrs: {
                                                          placement: "right",
                                                          trigger: "hover",
                                                          "visible-arrow": false,
                                                          width: 366,
                                                          "popper-class":
                                                            "bio-search-setting__popover",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "algorithm-popover",
                                                          {
                                                            attrs: {
                                                              options:
                                                                _vm
                                                                  .settingConfig
                                                                  .algorithm
                                                                  .options,
                                                            },
                                                          }
                                                        ),
                                                        _c("PtIcon", {
                                                          attrs: {
                                                            slot: "reference",
                                                            icon: "SolidInfo",
                                                          },
                                                          slot: "reference",
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                { staticClass: "row-space" },
                                                [
                                                  _vm.settingConfig.algorithm
                                                    .options.length > 1
                                                    ? _c(
                                                        "ElSelect",
                                                        {
                                                          staticClass:
                                                            "search-preference__select",
                                                          attrs: {
                                                            id: "test_algorithm_select",
                                                            disabled:
                                                              _vm.settingConfig
                                                                .defaultAlgorithm
                                                                .value,
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleAlgorithmChange(
                                                                _vm
                                                                  .settingConfig
                                                                  .algorithm
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.settingConfig
                                                                .algorithm
                                                                .value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .settingConfig
                                                                  .algorithm,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "settingConfig.algorithm.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.settingConfig
                                                            .algorithm.options,
                                                          function (option) {
                                                            return _c(
                                                              "ElOption",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "search-preference__optionText",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .settingConfig
                                                                  .algorithm
                                                                  .options[0]
                                                                  .label
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm.isActive(_vm.settingConfig.matrix)
                                            ? _c(
                                                "div",
                                                { staticClass: "row-space" },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "search-preference__title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Search.labels.matrix"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "ElSelect",
                                                        {
                                                          staticClass:
                                                            "search-preference__select",
                                                          attrs: {
                                                            id: "test_matrix_select",
                                                            placeholder:
                                                              "Scoring matrix",
                                                            disabled:
                                                              _vm.settingConfig
                                                                .defaultAlgorithm
                                                                .value,
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChangeMatrix,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.settingConfig
                                                                .matrix.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .settingConfig
                                                                  .matrix,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "settingConfig.matrix.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.settingConfig
                                                            .matrix.options,
                                                          function (option) {
                                                            return _c(
                                                              "ElOption",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isActive(
                                            _vm.settingConfig.wordSize
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "row-space" },
                                                [
                                                  _c(
                                                    "div",
                                                    { attrs: { span: 10 } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "search-preference__title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Search.labels.wordSize"
                                                                )
                                                              ) +
                                                              "(" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Search.labels.wordSizeHold"
                                                                )
                                                              ) +
                                                              ") "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { attrs: { span: 14 } },
                                                    [
                                                      _c(
                                                        "ElSelect",
                                                        {
                                                          staticClass:
                                                            "search-preference__select",
                                                          attrs: {
                                                            id: "test_word_size_select",
                                                            placeholder:
                                                              "Word size",
                                                            disabled:
                                                              _vm.settingConfig
                                                                .defaultAlgorithm
                                                                .value,
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleAlgorithmFieldsChange(
                                                                _vm
                                                                  .settingConfig
                                                                  .wordSize
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.settingConfig
                                                                .wordSize.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .settingConfig
                                                                  .wordSize,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "settingConfig.wordSize.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.settingConfig
                                                            .wordSize.options,
                                                          function (option) {
                                                            return _c(
                                                              "ElOption",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isActive(
                                            _vm.settingConfig.matchScores
                                          )
                                            ? _c(
                                                "div",
                                                { staticClass: "row-space" },
                                                [
                                                  _c("div", [
                                                    _c("div", {
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.$t(
                                                            "Search.labels.matchScores"
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "ElSelect",
                                                        {
                                                          staticClass:
                                                            "search-preference__select",
                                                          attrs: {
                                                            id: "test_math_scores_select",
                                                            placeholder:
                                                              "matchScores",
                                                            disabled:
                                                              _vm.settingConfig
                                                                .defaultAlgorithm
                                                                .value,
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.handleChangeMatchScores,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.settingConfig
                                                                .matchScores
                                                                .value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .settingConfig
                                                                  .matchScores,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "settingConfig.matchScores.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.settingConfig
                                                            .matchScores
                                                            .options,
                                                          function (option) {
                                                            return _c(
                                                              "ElOption",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isActive(_vm.settingConfig.gaps)
                                            ? _c(
                                                "div",
                                                { staticClass: "row-space" },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "search-preference__title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Search.labels.gapCosts"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "ElSelect",
                                                        {
                                                          staticClass:
                                                            "search-preference__select",
                                                          attrs: {
                                                            id: "test_gaps_select",
                                                            disabled:
                                                              _vm.settingConfig
                                                                .defaultAlgorithm
                                                                .value,
                                                            placeholder:
                                                              "Gap costs",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleAlgorithmFieldsChange(
                                                                _vm
                                                                  .settingConfig
                                                                  .gaps
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.settingConfig
                                                                .gaps.value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .settingConfig
                                                                  .gaps,
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "settingConfig.gaps.value",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.settingConfig.gaps
                                                            .options,
                                                          function (option) {
                                                            return _c(
                                                              "ElOption",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ],
          _c("div", { staticClass: "search-preference__reset" }, [
            _c(
              "button",
              {
                staticClass: "pt-ui-btn",
                on: { click: _vm.resetPreferenceSet },
              },
              [_vm._v(" " + _vm._s(_vm.$t("Search.propver.reset")) + " ")]
            ),
          ]),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }